import React, { useState } from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";

// Bump when framework badge files are replaced under the same names, so
// browsers fetch the new image instead of a cached copy (the CDN serves them
// with a one-day cache).
const FRAMEWORK_LOGO_VERSION = 2;

// Same place integration logos are served from: <CDN>/logos/<file name>.
export const frameworkLogoUrl = (logoPath) =>
  logoPath
    ? `${process.env.REACT_APP_POLICY_DOC_URL}/logos/${encodeURIComponent(logoPath)}?v=${FRAMEWORK_LOGO_VERSION}`
    : null;

// framework.logoPath is a file name. Framework badges carry their own rounded
// shape, so the image is shown as is at a fixed size, never clipped. A plain
// shield stands in when there is no logo or it does not load.
const FrameworkLogo = ({ framework, size = 48, alt = "" }) => {
  const theme = useTheme();
  const [failedUrl, setFailedUrl] = useState(null);
  const url = frameworkLogoUrl(framework.logoPath);

  if (!url || failedUrl === url) {
    return (
      <Box
        aria-hidden={alt ? undefined : true}
        sx={{
          width: size,
          height: size,
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: `${Math.round(size * 0.22)}px`,
          backgroundColor: theme.customColors.background.light,
        }}
      >
        <ShieldOutlinedIcon
          sx={{
            fontSize: Math.round(size * 0.55),
            color: theme.customColors.icons.dark,
          }}
        />
      </Box>
    );
  }
  return (
    <Box
      component="img"
      src={url}
      alt={alt}
      onError={() => setFailedUrl(url)}
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        objectFit: "contain",
        display: "block",
      }}
    />
  );
};

export default FrameworkLogo;
